.df{user-select:none;}